<form *ngIf="isOpened" [formGroup]="form" (submit)="onSubmit()" class="col-10 col-sm-6 m-0 p-0">
  <ds-input
    class="mt-4 input"
    formControlName="cardNumber"
    type="text"

    [label]="'paymentForm.cardNumber' | cxTranslate"
    [placeholder]="'paymentForm.cardNumber' | cxTranslate"
    [required]="true"
    [showErrorMessages]="showErrorMessages"
  >
  </ds-input>

  <ds-input
    class="mt-4"
    formControlName="expiration"
    type="text"

    [label]="'paymentForm.expirationDate' | cxTranslate"
    [placeholder]="'paymentForm.expirationDate' | cxTranslate"
    [required]="true"
    [showErrorMessages]="showErrorMessages"
  >
  </ds-input>

  <ds-input
    class="mt-4"
    formControlName="cvv"
    type="text"

    [label]="'paymentForm.securityCode' | cxTranslate"
    [placeholder]="'paymentForm.securityCode' | cxTranslate"
    [required]="true"
    [showErrorMessages]="showErrorMessages"
  >
  </ds-input>

  <div class="mt-4 ds-grid p-0">
    <div class="row flex-row-reverse justify-content-center">
      <div class="col-5 px-3">
        <button type="submit" class="w-100 ds-button ds-button--primary" [disabled]="false"
        >
          {{ 'common.submit' | cxTranslate }}
        </button>
      </div>
      <div *ngIf="isClosable" class="col-5 px-3">
        <button type="button" class="w-100 ds-button ds-button--secondary" [disabled]="false"
                (click)="onCancel()"
        >
          {{ 'common.cancel' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
</form>
